import axios from 'axios';
import qs from "qs";

const mainAPI = axios.create({
    baseURL: URL_API
});

mainAPI.interceptors.request.use(async (request) => {
    if (localStorage.getItem('token')){
        request.headers.Authorization = localStorage.getItem('token');
    }
    return request;
}, error => Promise.reject(error));


mainAPI.interceptors.response.use(response => response, error =>
        Promise.reject(error),
);


const getUser = () => mainAPI.post('user/getaccount', {});
const getContacts = ({userId}) => mainAPI.get(`user/${userId}/contacts`);
const login = ({id_corporation, username, password}) => mainAPI.post('apprendo/accessToken', qs.stringify({id_corporation, username, password}));
const registerUser = ({id_corporation, name, email, password}) => mainAPI.post('user/registeraccount', qs.stringify({id_corporation, name, email, password}));

const getContactsUser = ({body}) => mainAPI.post('user/getContactsUser', qs.stringify(body));
const getCorporationData = ({domain,catalogue_path}) => mainAPI.post('user/getcorporation', qs.stringify({domain,catalogue_path}));
const getContactInfo = ({userId}) => mainAPI.get(`user/${userId}/contact`);
const getFileUploadURL =  ({body}) => mainAPI.post('course/getFileUploadURL', qs.stringify(body));
const getCourses = (filters) => mainAPI.post('search/getcourses', qs.stringify({...filters, subdomain: window.DOMAIN}));
const saveRequisites =  (body) => mainAPI.post('checkout/savevalidationrequisites', qs.stringify(body));
const saveReaction =  (body) => mainAPI.post('search/savereactioncourse', qs.stringify(body));
const getCourse = (courseID) => mainAPI.post('search/getcourse', qs.stringify({id_course: courseID,subdomain: window.DOMAIN}));
const getCourseByCat = (courseID, cataloguePath) => mainAPI.post('search/getcourse', qs.stringify({id_course: courseID, catalogue_path: cataloguePath,subdomain: window.DOMAIN}));
const addToWaitList = (courseID,id_seat_type, id_course_seat, seat_name) => mainAPI.post('user/enrollInWaitList', qs.stringify({id_course: courseID,id_seat_type: id_seat_type, id_course_seat: id_course_seat, seat_name:seat_name}));
const createCourse =  (body) => mainAPI.post('course/saveUpdateCourse', qs.stringify(body));
const createPath =  (body) => mainAPI.post('course/saveUpdatePath', qs.stringify(body));
const userPreferences = () => mainAPI.get('user/preferences');
const updateUserPreferences = (userPreferences) => mainAPI.put('user/preferences', userPreferences);
const userFavorites = (userPreferences) => mainAPI.get('user/favorites', userPreferences);
const getLocation = ({id_cat_location}) => mainAPI.get(`search/getLocation/${id_cat_location}`);
const getmycourses = () => mainAPI.get(`search/getmycourses`,{});

export default {
	getContactsUser,
    getUser,
    getContacts,
    getFileUploadURL,
    login,
    registerUser,
    getCorporationData,
    getContactInfo,
    getCourses,
    saveRequisites,
    saveReaction,
    getCourse,
    getCourseByCat,
    addToWaitList,
    createCourse,
    createPath,
    userPreferences,
    updateUserPreferences,
    userFavorites,
    getLocation,
    getmycourses,
};